import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api, errorText } from "@/lib/api";
import { Field, Panel } from "@/components/admin/shared";

export const ShopAlertPanel = ({ settings, save }) => {
  const [a, setA] = useState(settings.shop_alert);
  const [testing, setTesting] = useState(false);
  const test = async () => {
    setTesting(true);
    try { await api.post("/admin/shop-alert/test"); toast.success("Mensaje de prueba enviado. Revisa tu WhatsApp."); } catch (e) { toast.error(errorText(e)); }
    setTesting(false);
  };
  return (
    <Panel title="Aviso al WhatsApp del taller">
      {a.env_configured && <p className="mb-4 rounded-sm border border-green/30 bg-green/5 p-3 text-sm font-semibold text-green" data-testid="shop-alert-env-note">Número y API key de CallMeBot guardados de forma segura en el servidor. Los avisos de citas nuevas se envían automáticamente.</p>}
      <ol className="mb-5 list-decimal space-y-1 pl-5 text-sm text-ink2">
        <li>Desde el WhatsApp del dueño, agrega el contacto de CallMeBot que aparece en <a className="font-semibold text-green underline" href="https://www.callmebot.com/blog/free-api-whatsapp-messages/" target="_blank" rel="noopener noreferrer">callmebot.com</a>.</li>
        <li>Envíale exactamente: <b>I allow callmebot to send me messages</b></li>
        <li>Te responderá con tu <b>APIKEY</b>. Pégala aquí con tu número y guarda.</li>
      </ol>
      <div className="grid gap-4 sm:grid-cols-2">
        <Field id="shop-alert-phone" label="Número del dueño (con 52)" placeholder="529991919300" value={a.phone} onChange={(e) => setA({ ...a, phone: e.target.value.replace(/[^\d+]/g, "") })} />
        <Field id="shop-alert-apikey" label="API key de CallMeBot" type="password" placeholder={a.has_key ? "Guardada (escribe para reemplazar)" : ""} value={a.apikey?.startsWith("••••") ? "" : a.apikey} onChange={(e) => setA({ ...a, apikey: e.target.value })} />
        <label className="flex items-center gap-3 text-sm sm:col-span-2"><Switch checked={a.enabled} onCheckedChange={(v) => setA({ ...a, enabled: v })} data-testid="shop-alert-enabled" /> Avisarme por WhatsApp de cada cita y cotización nueva</label>
      </div>
      <div className="mt-6 flex flex-wrap gap-3">
        <button className="btn-gold" onClick={async () => { const d = await save({ shop_alert: a }); if (d) setA(d.shop_alert); }} data-testid="shop-alert-save-btn">Guardar</button>
        <button className="btn-ghost" onClick={test} disabled={testing} data-testid="shop-alert-test-btn"><Send size={16} /> Enviar prueba</button>
      </div>
    </Panel>
  );
};
